import { TOKEN } from "../utils/constants";

export function setToken(token) {
  localStorage.setItem(TOKEN, token);
}

export function getToken() {
  return localStorage.getItem(TOKEN);
}

export function removeToken() {
  localStorage.removeItem(TOKEN);
}

// Header de autenticación solo si hay token — pedidos y pagos los usan tanto
// el Admin (con sesión) como el Cliente de la mesa (sin sesión), con las
// mismas funciones.
export function authHeader(token) {
  return token ? { Authorization: `Bearer ${token}` } : {};
}
